<button type="button"
        class="ace-btn btn-primary has-icon"
        [ngClass]="buttonClass"
        helpTooltip
        [position]="tooltipPosition"
        [tooltipText]="pinnedComment"
        [helpDisabled]="!pinnedComment"
        [disabled]="disabled"
        (click)="showCommentsDialog()">
    <i class="fa" [ngClass]="(hasComments ? 'fa-commenting' : 'fa-comment-o')"></i>
</button>
